import { render, staticRenderFns, recyclableRender, components } from "./tn-row-notice.vue?vue&type=template&id=15a5161a&scoped=true&"
var renderjs
import script from "./tn-row-notice.vue?vue&type=script&lang=js&"
export * from "./tn-row-notice.vue?vue&type=script&lang=js&"
import style0 from "./tn-row-notice.vue?vue&type=style&index=0&id=15a5161a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5161a",
  null,
  false,
  components,
  renderjs
)

export default component.exports